"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const tooltipTitles_1 = __importDefault(require("./tooltipTitles"));
const labels_1 = __importDefault(require("./labels"));
const placeholders_1 = __importDefault(require("./placeholders"));
const messages_1 = __importDefault(require("./messages"));
const carousel_1 = __importDefault(require("./carousel"));
const accountCreation_1 = __importDefault(require("./accountCreation"));
const joiningUser_1 = __importDefault(require("./joiningUser"));
const codeInput_1 = __importDefault(require("./codeInput"));
const socialNetworks_1 = __importDefault(require("./socialNetworks"));
const dialogs_1 = __importDefault(require("./dialogs"));
const houseForm_1 = __importDefault(require("./houseForm"));
const invitationAccept_1 = __importDefault(require("./invitationAccept"));
const accountConflictModal_1 = __importDefault(require("./accountConflictModal"));
const invitationAcceptModal_1 = __importDefault(require("./invitationAcceptModal"));
const invitationWhatsapp_1 = __importDefault(require("./invitationWhatsapp"));
const policyAcceptModal_1 = __importDefault(require("./policyAcceptModal"));
const invitationEmail_1 = __importDefault(require("./invitationEmail"));
const components_1 = __importDefault(require("./components"));
exports.default = {
  tooltipTitles: tooltipTitles_1.default,
  labels: labels_1.default,
  placeholders: placeholders_1.default,
  messages: messages_1.default,
  carousel: carousel_1.default,
  accountCreation: accountCreation_1.default,
  joiningUser: joiningUser_1.default,
  codeInput: codeInput_1.default,
  socialNetworks: socialNetworks_1.default,
  dialogs: dialogs_1.default,
  houseForm: houseForm_1.default,
  invitationAccept: invitationAccept_1.default,
  accountConflictModal: accountConflictModal_1.default,
  invitationAcceptModal: invitationAcceptModal_1.default,
  policyAcceptModal: policyAcceptModal_1.default,
  invitationWhatsapp: invitationWhatsapp_1.default,
  invitationEmail: invitationEmail_1.default,
  components: components_1.default
};